import { useEffect } from 'react';
import { useState } from 'react';
import { basedAxios } from '../../../store/Store';
import Autocomplete from '../../../components/AutoComplete/AutoComplete';
import EventLabel from '../../../components/EventLabel/EventLabel';

export default function OrderAutoComplete({ referencePerson, eventId, orderId, setOrderExtra }) {
  const [orders, setOrders] = useState([]);

  const fetchOrders = async () => {
    const { data } = await basedAxios.get(`./hotel/getroomates/${eventId}`);
    const orderData = data
      .filter(order => order.orderId !== orderId)
      .map(order => ({
        ...order,
        name: `${order?.person?.firstName} ${order?.person?.lastName}`,
        company: order?.company?.name,
      }));
    setOrders(orderData);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleChange = order => {
    const targetOrder = orders?.find(o => o.name === order?.name);
    if (targetOrder) {
      setOrderExtra(targetOrder.name, targetOrder.orderId);
    }
  };

  return (
    <div className="w-full">
      <div className="mb-2">
        <label>
          <EventLabel name="SelectRoomMate" groupName="CMS.Hotel" />
        </label>
      </div>
      <Autocomplete
        onChange={handleChange}
        className="w-full"
        inputPrepend={<i className="ri-expand-up-down-line" />}
        value={orders?.find(o => o.orderId === referencePerson)}
        displayOption={({ selected, active, option }) => (
          <>
            <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>
              {option?.name ?? option} {option.company ? `(${option.company})` : null}
            </span>
            {selected ? <span className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-teal-600'}`}></span> : null}
          </>
        )}
        options={[
          ...orders.map(order => ({
            name: `${order?.person?.firstName} ${order?.person?.lastName}`,
            company: order?.company?.name,
          })).sort((a, b) => a.name.localeCompare(b.name))
        ]}
      />
    </div>
  );
}
